import React from 'react';
import { isMobile } from 'react-device-detect';

import { Fullscreen, PlayArrowRounded } from '@material-ui/icons';

import volumeOn from '../../../../assets/icons/volume-on.png';
import volumeMuted from '../../../../assets/icons/volume-muted.png';

import './css/AnchorLiveFeedPlayerControls.css';
import './css/AnchorLiveFeedPlayerControls.mobile.css';

class AnchorLiveFeedPlayerControls extends React.Component {

  handleVolumeChange = event => {
    this.props.onVolumeChange(event.target.value);
  }

  render () {
    const {
      muted,
      mutePlayer,
      toggleFullscreen,
      volume,
      showPlay,
      broadcasterClosedSession,
      spotlighterClosedSession,
      playVideo,
      disableMute,
      shouldHideVolumeRange = false,
    } = this.props;
    return (
      <>
      {showPlay && !broadcasterClosedSession && !spotlighterClosedSession && (
        <div className="play-button" onClick={playVideo}>
          <PlayArrowRounded fontSize="inherit" />
        </div>
      )}
        <div className="anchor-live-feed-player-controls">
          <div className="volume-container">
            <button className="volume-container__cta-mute" title="Mute/Unmute sound" onClick={mutePlayer} disabled={disableMute}>
              <span className="icon-sound">
                {!muted ? (
                  <img src={volumeOn} alt="" />
                ) : (
                  <img src={volumeMuted} alt="" />
                )}
              </span>
            </button>
            {!isMobile && !shouldHideVolumeRange && (
              <div className="slider-container">
                <input
                  type="range"
                  className="volume-range"
                  onChange={this.handleVolumeChange}
                  value={volume}
                  step={0.1}
                  min={0}
                  max={1}
                />
              </div>
            )}
          </div>
          {!isMobile && (
            <div title="Switch to full screen" onClick={toggleFullscreen}>
              <span className="icon-fullscreen">
                <Fullscreen fontSize="inherit" />
              </span>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default AnchorLiveFeedPlayerControls;